const initialState = {
    zoomLevel: '',
};

const zoomLevelReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ZOOM_LEVEL':
            return { ...state, zoomLevel: action.payload.zoomLevel };
        default:
            return state;
    }
};

export default zoomLevelReducer;